import { ErrorCode, PortalApiError, isFetchBaseQueryError, isPortalApiError } from '@afterpaytouch/portal-api'
import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'

export enum TopazError {
  DuplicatePayCardError = 'duplicate_pay_card_error',
  ExceededMaxAttemptsEnteringDetails = 'exceeded-max-attempts-entering-details',
}

// Recoverable Terminal Errors
export const recoverableTerminalErrorWhiteList: ErrorCode[] = [
  ErrorCode.AmountTooHigh,
  ErrorCode.MaxActiveOrdersReached,
  ErrorCode.OverduePaymentsCheckoutPaymentEligible,
]

export const toRecoverableTerminalError = (str?: string | string[]): string | null => {
  if (Array.isArray(str)) {
    str = str[0]
  }
  if (typeof str === 'undefined') {
    return null
  }
  switch (str) {
    case ErrorCode.AmountTooHigh:
    case ErrorCode.MaxActiveOrdersReached:
    case ErrorCode.OverduePaymentsCheckoutPaymentEligible:
      return str
    default:
      return null
  }
}

export const getError = (error: FetchBaseQueryError | SerializedError | undefined): PortalApiError | undefined => {
  if (isFetchBaseQueryError(error)) {
    return error?.data
  }
  if (isPortalApiError(error)) {
    return error
  } else {
    return undefined
  }
}
